import { Button, Col, Row, RowProps } from 'antd'
import React, { FC } from 'react'

interface Props extends RowProps {
  title: string
  buttonText: string
  onClick: () => void
}

const CardTitleWithButton: FC<Props> = ({
  title,
  buttonText,
  onClick,
  justify = 'space-between',
  align = 'middle',
  gutter = 20,
  ...props
}) => {
  return (
    <>
      <Row justify={justify} align={align} gutter={gutter} {...props}>
        <Col>{title}</Col>
        <Col>
          <Button type='primary' onClick={onClick}>
            {buttonText}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default CardTitleWithButton
